module.exports = __webpack_public_path__ + "media/images/main/work1-c9cb38b7a5e44ee2825293adf096e3cb.jpg";